import { SxProps, Theme } from "@mui/material";
import { alpha } from "@mui/material/styles";

const adminProfileSectionStyles: Record<string, SxProps<Theme>> = {
  section: {
    scrollMarginTop: 24,
  },
  card: {
    p: 2.5,
    borderRadius: 3,
    border: (t) => `1px solid ${alpha(t.palette.divider, 0.12)}`,
    bgcolor: "background.paper",
    boxShadow: (t) =>
      t.palette.mode === "dark"
        ? `0 4px 20px ${alpha("#000", 0.3)}`
        : `0 2px 12px ${alpha("#000", 0.06)}`,
  },
  stat: {
    fontWeight: 700,
    fontSize: "1.5rem",
    color: "#f8481c",
  },
};

export default adminProfileSectionStyles;
